export default __webpack_public_path__ + "static/media/GLEnglish.e65340f7.webp";